import { useOwlSpotlight, type OwlSpotlightLeg } from "../../owl/useOwlSpotlight.ts";

function pickLabel(leg: OwlSpotlightLeg): string {
  if (leg.market === "multiscores") return leg.selection.replaceAll("/", " / ");
  if (leg.market === "result_btts") {
    return `${leg.selection === "home_yes" ? leg.home_team : leg.away_team} win & BTTS`;
  }
  if (leg.market === "btts") return "Both teams to score";
  if (leg.market === "ou") return leg.selection === "over_3_5" ? "Over 3.5 goals" : "Over 2.5 goals";
  return `${leg.selection === "home" ? leg.home_team : leg.away_team} to win`;
}

export function OwlSpotlight({ sessionDate }: { sessionDate: string }): JSX.Element {
  const slip = useOwlSpotlight(sessionDate);
  return (
    <section className="owl-spotlight" aria-label="Two-leg spotlight">
      <div className="owl-spotlight-head">
        <h2>Two-leg spotlight</h2>
        <span>{slip ? `${slip.combined_odds.toFixed(2)} odds` : "No verified pair tonight"}</span>
      </div>
      {slip ? (
        <div className="owl-spotlight-legs">
          {slip.selections.map((leg) => (
            <div className="owl-spotlight-leg" key={leg.fixture_id}>
              <div className="owl-spotlight-match">{leg.home_team} v {leg.away_team}</div>
              <div className="owl-spotlight-meta">
                <span>{leg.league}</span>
                <span>{new Intl.DateTimeFormat("en-GH", { timeZone: "Africa/Accra", hour: "2-digit", minute: "2-digit" }).format(new Date(leg.kickoff_at))}</span>
                {leg.bookmaker ? <span>{leg.bookmaker}</span> : null}
              </div>
              <div className="owl-spotlight-pick">
                <span>{pickLabel(leg)}</span>
                <strong>{leg.odds.toFixed(2)}</strong>
              </div>
            </div>
          ))}
        </div>
      ) : null}
    </section>
  );
}
